import { normalizeText } from '../helpers'

export type ExplorerSort = 'recent-activity' | 'newest-filed'

export interface ExplorerState {
  query: string
  status: string | null
  chamber: string | null
  subject: string | null
  withVotes: boolean | null
  sort: ExplorerSort
}

export function defaultExplorerState(): ExplorerState {
  return {
    query: '',
    status: null,
    chamber: null,
    subject: null,
    withVotes: null,
    sort: 'recent-activity',
  }
}

export function explorerStateFromQueryPairs(pairs: [string, string][]): ExplorerState {
  const state = defaultExplorerState()
  for (const [key, value] of pairs) {
    switch (key) {
      case 'q':
        state.query = value
        break
      case 'status':
        if (value) state.status = canonicalStatusSlug(value)
        break
      case 'chamber':
        if (value) state.chamber = canonicalChamberSlug(value)
        break
      case 'subject':
        if (value) state.subject = value
        break
      case 'withVotes':
        state.withVotes =
          value === 'true' ? true : value === 'false' ? false : null
        break
      case 'sort':
        if (value === 'newest-filed') state.sort = 'newest-filed'
        break
    }
  }
  return state
}

export function explorerStateToQueryPairs(state: ExplorerState): [string, string][] {
  const pairs: [string, string][] = []
  if (state.query) pairs.push(['q', state.query])
  if (state.status !== null) pairs.push(['status', state.status])
  if (state.chamber !== null) pairs.push(['chamber', state.chamber])
  if (state.subject !== null) pairs.push(['subject', state.subject])
  if (state.withVotes !== null) pairs.push(['withVotes', String(state.withVotes)])
  if (state.sort === 'newest-filed') pairs.push(['sort', 'newest-filed'])
  return pairs
}

export function explorerStatesEqual(a: ExplorerState, b: ExplorerState): boolean {
  return (
    a.query === b.query &&
    a.status === b.status &&
    a.chamber === b.chamber &&
    a.subject === b.subject &&
    a.withVotes === b.withVotes &&
    a.sort === b.sort
  )
}

export function canonicalSubject(subjects: string[], value: string): string | null {
  const wanted = normalizeText(value).trim()
  if (!wanted) return null
  return subjects.find((s) => normalizeText(s) === wanted) ?? null
}

export function canonicalStatusSlug(value: string): string | null {
  const v = normalizeText(value)
  return v === 'en-tramitacion' || v === 'publicado' ? v : null
}

export function canonicalChamberSlug(value: string): string | null {
  const v = normalizeText(value)
  return v === 'senado' || v === 'diputados' ? v : null
}
